<template>
  <div class="height-percent-100 bc-white br-4 display-flex fd-column">
    <div class="display-flex ai-center jc-space-between fs-14 color-info padding-20 pt-14 pb-14 br-4" style="overflow:hidden;">
      <div class="display-flex ai-center">
        <div class="display-flex ai-center cursor-pointer" @click="back">
          <i class="el-icon-back mr-6 fs-18"></i>
          <span>返回</span>
        </div>
        <el-divider direction="vertical" class="ml-20 mr-20"></el-divider>
        <b class="fs-18 color-black">{{ $route.query.libraryTitle }}</b>
      </div>
      <div>
        <el-button type="" size="small" @click="preview">预览</el-button>
        <el-button type="primary" size="small" @click="submit" :loading="submitLoading">保存</el-button>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="flex-1 display-flex">
      <el-tabs type="border-card" class="tabs">
        <el-tab-pane label="题型">
          <div v-for="(item, index) in componentList" :key="index">
            <b class="fs-14">{{item.groupName}}</b>
            <draggable
              @end="end"
              :clone="cloneElement"
              class="group"
              v-model="item.children"
              :sort="false"
              :group="{
                name: 'component',
                pull: 'clone',
                put: false
              }">
              <div @click="pushComponent(_item)" class="component" v-for="(_item, _index) in item.children" :key="_index">
                <i class="iconfont mr-8" :class="_item.componentIcon"></i>
                <span>{{_item.componentName}}</span>
              </div>
            </draggable>
          </div>
        </el-tab-pane>
        <el-tab-pane label="题库">题库</el-tab-pane>
      </el-tabs>
      <div class="content">
        <el-scrollbar ref="scrollbar" style="height: calc(100vh - 220px)">
          <draggable
            class="list"
            forceFallback
            :animation="200"
            ghostClass="ghost"
            handle=".el-icon-rank"
            v-model="questionList"
            :group="{
              name: 'component'
            }">
            <transition-group class="height-percent-100 display-block">
              <div
                class="item"
                :class="{active: item.active, error: item.error}"
                v-for="(item, index) in questionList"
                :key="item.uid">
                <div
                  class="display-flex ai-flex-start padding-20 pt-14"
                  @click="clickQuestion(item)"
                  :id="item.uid">
                  <div class="pt-6 width-40">
                    <b>{{index + 1}}</b>
                  </div>
                  <div class="flex-1">
                    <div class="display-flex ai-flex-start jc-space-between">
                      <b @click="editTitle(item)" class="width-percent-80 pt-6" style="min-height: 26px" v-if="!item.editTitle">{{item.title}}</b>
                      <el-input
                        type="textarea"
                        autosize
                        :ref="item.uid"
                        v-else
                        size="small"
                        class="width-percent-80"
                        @blur="item.editTitle = false"
                        v-model="item.title"></el-input>
                      <span v-if="item.componentType !== 'message'" class="color-info pt-6">( {{item.score}}分 )</span>
                    </div>
                    <div class="mt-12">
                      <el-input
                        v-if="item.componentType === 'message'"
                        readonly
                        placeholder="请输入"
                        type="textarea"
                        autosize
                        v-model="item.answer"
                        size="small"
                        class="width-percent-80"></el-input>
                      <draggable v-model="item.options" handle=".el-icon-d-caret">
                        <transition-group>
                          <div v-for="i in item.options" :key="i.value" class="display-flex ai-center jc-space-between pt-4 pb-4">
                            <div class="flex-1 display-flex ai-center">
                              <el-checkbox v-if="item.componentType === 'duoxuan'" v-model="item.answer" :label="i.value">{{  }}</el-checkbox>
                              <el-radio v-else v-model="item.answer" :label="i.value" class="mr-0">{{  }}</el-radio>
                              <p @click="editOption(i)" v-if="!i.edit" class="margin-0 fs-14 width-percent-80 display-flex ai-center" style="min-height: 32px">{{i.label}}</p>
                              <el-input
                                type="textarea"
                                autosize
                                @blur="i.edit = false"
                                :ref="i.value"
                                v-else
                                v-model="i.label"
                                size="small"
                                class="width-percent-80"></el-input>
                            </div>
                            <div class="display-flex ai-center fd-row-reverse color-info width-130">
                              <i class="el-icon-d-caret ml-8 cursor-move"></i>
                              <i @click="delOption(item, i.value)" class="ml-10 el-icon-remove-outline cursor-pointer"></i>
                              <span class="color-success fs-14" v-if="item.answer.includes(i.value)">( 正确答案 )</span>
                            </div>
                          </div>
                        </transition-group>
                      </draggable>
                      <div v-if="['danxuan', 'duoxuan'].includes(item.componentType)">
                        <el-button class="pb-0" @click="addOption(item)" type="text" icon="el-icon-plus">添加选项</el-button>
                      </div>
                    </div>
                  </div>
                  <div class="display-flex ai-center color-info mt-8">
                    <i class="ml-14 el-icon-rank cursor-move"></i>
                    <i @click.stop="copyQuestion(item, index)" class="ml-14 el-icon-document-copy cursor-pointer"></i>
                    <i @click.stop="delQuestion(item)" class="ml-14 el-icon-delete cursor-pointer"></i>
                  </div>
                </div>
                <div class="errorMessage" v-if="item.error">
                  {{item.errorMessage}}
                </div>
              </div>
              <div key="empty" v-if="!questionList.length" class="height-percent-100 fd-column display-flex ai-center jc-center">
                <el-empty description="请点击右侧或拖入题型进行添加题目"></el-empty>
              </div>
            </transition-group>
          </draggable>
        </el-scrollbar>
      </div>
      <div class="setting">
        <template v-if="activeQuestion">
          <b>题型</b>
          <div class="display-flex ai-center mt-14">
            <p class="mb-0 mt-0">{{activeQuestion.componentName}}</p>
            <el-popover
              placement="top"
              width="160"
              v-model="popover.show">
              <p class="mt-0 mb-10 fs-14">选择你要切换的题型</p>
              <el-select class="mb-10" size="mini" v-model="popover.componentType" placeholder="请选择">
                <el-option
                  v-for="item in componentList[0].children"
                  :key="item.componentType"
                  :label="item.componentName"
                  :value="item.componentType">
                </el-option>
              </el-select>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="popover.show = false">取消</el-button>
                <el-button type="primary" size="mini" @click="submitPopover">确定</el-button>
              </div>
              <i slot="reference" class="el-icon-edit cursor-pointer ml-10"></i>
            </el-popover>
          </div>
          <template v-if="activeQuestion.componentType !== 'message'">
            <template v-if="activeQuestion.componentType === 'duoxuan'">
              <el-divider class="mt-14"></el-divider>
              <p><b>计分方式</b></p>
              <el-select size="small" v-model="activeQuestion.scoreMethod" placeholder="请选择计分方式">
                <el-option
                  v-for="item in options.scoreMethod"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
            <el-divider class="mt-14"></el-divider>
            <p><b>该题分数</b></p>
            <el-input-number class="width-80 mr-10 input-number-text-left" :controls="false" size="small" v-model="activeQuestion.score" :min="0" :precision="0"></el-input-number>
            <span>分</span>
            <el-divider class="mt-14"></el-divider>
            <p><b>题目解析</b></p>
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入题目解析"
              v-model="activeQuestion.description">
            </el-input>
          </template>
        </template>
        <div v-else>
          <span class="color-info">请添加题目</span>
        </div>
      </div>
    </div>
    <exam-preview v-if="showPreview" :show="showPreview" :default-question-list="questionList" @close="showPreview = false"></exam-preview>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import ExamPreview from '@/views/basicLibrary/exam/ExamPreview';
export default {
  name: 'ExamDesign',
  components: { ExamPreview, draggable },
  props: {},
  data () {
    return {
      submitLoading: false,
      popover: {
        show: false,
        componentType: ''
      },
      showPreview: false,
      options: {
        scoreMethod: [
          {
            label: '全部答对才得分',
            value: '1'
          },
          {
            label: '少选得一半分，错选0分',
            value: '2'
          }
        ]
      },
      componentList: [
        {
          groupName: '考试题型',
          children: [
            {
              componentType: 'danxuan',
              componentName: '单选题',
              componentIcon: 'icon-danxuan'
            },
            {
              componentType: 'duoxuan',
              componentName: '多选题',
              componentIcon: 'icon-duoxuan'
            },
            {
              componentType: 'panduan',
              componentName: '判断题',
              componentIcon: 'icon-panduan'
            // },
            // {
            //   componentType: 'tiankong',
            //   componentName: '填空题',
            //   componentIcon: 'icon-tiankong'
            }
          ]
        },
        {
          groupName: '信息题',
          children: [
            {
              componentType: 'message',
              componentName: '姓名',
              componentIcon: 'icon-xingming'
            },
            {
              componentType: 'message',
              componentName: '手机',
              componentIcon: 'icon-shouji'
            },
            {
              componentType: 'message',
              componentName: '邮箱',
              componentIcon: 'icon-youxiang'
            }
          ]
        }
      ],
      questionList: []
    }
  },
  filters: {},
  computed: {
    /**
     * 当前活动的组件
     * @returns {null|*}
     */
    activeQuestion () {
      if (this.questionList.length) {
        return this.questionList.filter(item => item.active)[0]
      } else {
        return null
      }
    },
    _questionList () {
      return JSON.parse(JSON.stringify(this.questionList))
    }
  },
  watch: {
    _questionList (newVal, oldVal) {
      if (newVal.length > 1) {
        // 试题库只能添加一个
        this.questionList = oldVal
        this.$message.warning('只能添加一个题目')
        this.$nextTick(() => {
          this.$refs.scrollbar.update()
        })
      }
    },
    'popover.show': {
      handler (val) {
        if (val) {
          this.popover.componentType = this.activeQuestion.componentType
        }
      }
    }
  },
  methods: {
    /**
     * 切换题型
     */
    submitPopover () {
      if (this.popover.componentType !== this.activeQuestion.componentType) {
        switch (this.popover.componentType) {
          case 'danxuan':
            this.activeQuestion.componentType = 'danxuan'
            this.activeQuestion.componentName = '单选题'
            this.activeQuestion.componentIcon = 'icon-danxuan'
            this.activeQuestion.scoreMethod = '1'
            this.activeQuestion.answer = this.activeQuestion.options[0].value
            break
          case 'duoxuan':
            this.activeQuestion.componentType = 'duoxuan'
            this.activeQuestion.componentName = '多选题'
            this.activeQuestion.componentIcon = 'icon-duoxuan'
            this.activeQuestion.scoreMethod = '1'
            this.activeQuestion.answer = [this.activeQuestion.options[0].value]
            break
          case 'panduan':
            this.activeQuestion.componentType = 'panduan'
            this.activeQuestion.componentName = '判断题'
            this.activeQuestion.componentIcon = 'icon-panduan'
            this.activeQuestion.scoreMethod = '1'
            this.activeQuestion.options = [
              {
                edit: false,
                label: '是',
                value: 'panduan-true'
              },
              {
                edit: false,
                label: '否',
                value: 'panduan-false'
              }
            ]
            this.activeQuestion.answer = this.activeQuestion.options[0].value
            break
        }
        this.popover.show = false
      }
    },
    /**
     * 添加选项
     * @param data
     */
    addOption (data) {
      data.options.push(
        {
          edit: false,
          label: `选项${data.options.length + 1}`,
          value: `${data.componentType}-${Math.floor(Math.random() * 1000000)}`
        }
      )
    },
    /**
     * 删除选项
     * @param data
     * @param value
     */
    delOption (data, value) {
      if (data.options.length === 2) {
        return this.$message.warning('至少保留俩个选项')
      } else {
        data.options = data.options.filter(item => item.value !== value)
        // 判断删除的是不是正确答案
        if (data.answer.includes(value)) {
          switch (data.componentType) {
            case 'danxuan':
              data.answer = ''
              break
            case 'duoxuan':
              data.answer = data.answer.filter(i => i !== value)
              break
          }
        }
      }
    },
    /**
     * 编辑选项
     * @param data
     */
    editOption (data) {
      data.edit = true
      this.$nextTick(() => {
        this.$refs[data.value][0].focus()
      })
    },
    /**
     * 修改题目名称
     * @param data
     */
    editTitle (data) {
      data.editTitle = true
      this.$nextTick(() => {
        this.$refs[data.uid][0].focus()
      })
    },
    /**
     * 复制题目
     * @param data
     * @param index
     */
    copyQuestion (data, index) {
      const newData = JSON.parse(JSON.stringify(data))
      newData.uid = `${newData.componentType}-${Math.floor(Math.random() * 1000000)}`
      this.questionList.splice(index + 1, 0, newData)
      for (const item of this.questionList) {
        item.active = item.uid === newData.uid
      }
    },
    /**
     * 删除题目
     * @param data
     */
    delQuestion (data) {
      this.$confirm('此操作将永久删除该题目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.questionList = this.questionList.filter(item => item.uid !== data.uid)
      }).catch(() => {})
    },
    /**
     * 点击题目
     * @param data
     */
    clickQuestion (data) {
      for (const item of this.questionList) {
        item.active = false
      }
      data.active = true
    },
    /**
     * 点击组件进行push
     * @param data
     */
    pushComponent (data) {
      this.questionList.push(this.cloneElement(data))
      const newDraggableIndex = this.questionList.length - 1
      const e = {
        to: {
          className: 'pushComponent'
        },
        newDraggableIndex
      }
      this.end(e)
    },
    /**
     * 拖拽结束
     * @param e
     */
    end (e) {
      if (e.to.className !== 'group') {
        for (const item of this.questionList) {
          item.active = false
        }
        this.questionList[e.newDraggableIndex].active = true
        this.$nextTick(() => {
          document.getElementById(this.questionList[e.newDraggableIndex].uid).scrollIntoView()
        })
      }
    },
    /**
     * 拖拽clone
     * @param item
     * @returns {any}
     */
    cloneElement (item) {
      const data = JSON.parse(JSON.stringify(item));
      data.uid = `${data.componentType}-${Math.floor(Math.random() * 1000000)}`
      data.title = data.componentName
      data.answer = ''
      data.active = false
      data.editTitle = false
      data.error = false
      data.errorMessage = ''
      switch (data.componentType) {
        case 'danxuan':
          data.scoreMethod = '1' // 得分方式
          data.options = [
            {
              edit: false,
              label: '选项1',
              value: `${data.componentType}-${Math.floor(Math.random() * 1000000)}`
            },
            {
              edit: false,
              label: '选项2',
              value: `${data.componentType}-${Math.floor(Math.random() * 1000000)}`
            }
          ] // 选项
          data.answer = data.options[0].value // 答案
          data.score = 10 // 分数
          data.description = '' // 解析
          break
        case 'duoxuan':
          data.scoreMethod = '1'
          data.options = [
            {
              edit: false,
              label: '选项1',
              value: `${data.componentType}-${Math.floor(Math.random() * 1000000)}`
            },
            {
              edit: false,
              label: '选项2',
              value: `${data.componentType}-${Math.floor(Math.random() * 1000000)}`
            }
          ]
          data.answer = [data.options[0].value]
          data.score = 10
          data.description = ''
          break
        case 'panduan':
          data.scoreMethod = '1'
          data.options = [
            {
              edit: false,
              label: '是',
              value: `${data.componentType}-true`
            },
            {
              edit: false,
              label: '否',
              value: `${data.componentType}-false`
            }
          ]
          data.answer = data.options[0].value
          data.score = 10
          data.description = ''
          break
      }
      return data
    },
    /**
     * 数据验证
     * @returns {boolean}
     */
    validate () {
      let flag = true
      if (this.questionList.length) {
        // 重置所有已选择项
        for (const item of this.questionList) {
          item.active = false
          item.error = false
          item.errorMessage = ''
          if (item.componentType !== 'message') {
            for (const _item of item.options) {
              _item.edit = false
            }
          }
        }
        for (const item of this.questionList) {
          // 判断标题有没有填写
          if (!item.title.trim()) {
            flag = false
            item.errorMessage = '标题未填写'
            item.active = true
            item.error = true
            document.getElementById(item.uid).scrollIntoView()
            item.editTitle = true
            this.$nextTick(() => {
              this.$refs[item.uid][0].focus()
            })
          }
          // 判断需不需要配置选项和答案
          if (item.componentType !== 'message') {
            // 判断选项有没有填写
            for (const _item of item.options) {
              if (!_item.label.trim()) {
                flag = false
                item.errorMessage = '选项未填写'
                item.active = true
                item.error = true
                document.getElementById(item.uid).scrollIntoView()
                _item.edit = true
                this.$nextTick(() => {
                  this.$refs[_item.value][0].focus()
                })
              }
            }
            // 判断有没有选择正确答案
            if (!item.answer.length) {
              flag = false
              item.errorMessage = '正确答案未选择'
              item.active = true
              item.error = true
              document.getElementById(item.uid).scrollIntoView()
            }
          }
          // 结束循环
          if (!flag) break
        }
      } else {
        this.$message.warning('未添加题目')
        flag = false
      }
      return flag
    },
    /**
     * 预览
     */
    preview () {
      if (this.validate()) {
        this.showPreview = true
      }
    },
    /**
     * 提交
     */
    submit () {
      if (this.validate()) {
        this.submitLoading = true
        const data = {
          ...this.questionList[0],
          questionSetId: this.$route.query.libraryId,
          answer: JSON.stringify(this.questionList[0].answer)
        }
        if (data.id) {
          this.$api.exam.update(data).then(res => {
            this.$message.success('编辑成功')
            this.submitLoading = false
            this.back()
          }).catch(() => {
            this.submitLoading = false
          })
        } else {
          this.$api.exam.save(data).then(res => {
            this.$message.success('添加成功')
            this.submitLoading = false
            this.back()
          }).catch(() => {
            this.submitLoading = false
          })
        }
      }
    },
    back () {
      this.$store.commit('SET_VIEWS', this.$store.state.views.filter(item => item.path !== this.$route.fullPath))
      this.$router.back()
    }
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    if (this.$route.query.info) {
      const data = JSON.parse(this.$route.query.info)
      data.answer = JSON.parse(data.answer)
      this.questionList.push(data)
    }
  },
  beforeUpdate () {
  },
  updated () {

  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  width: 240px;
  box-shadow: none;
  border: none;
  height: 100%;
  .group {
    display: grid;
    grid-gap: 12px;
    grid-template-columns: repeat(2, 1fr);
    font-size: 14px;
    padding: 12px 0;
  }
  .component {
    color: #666666;
    border-radius: 4px;
    border: 1px solid #D8D8D8;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
    cursor: pointer;
    &:hover {
      color: #1774FF;
      border-color: #1774FF;
    }
  }
}
.content {
  flex: 1;
  background-color: #EFF2F4;
  border-left: 1px solid #DCDFE6;
  border-right: 1px solid #DCDFE6;
  padding: 20px 4px 0 20px;

  .list {
    height: 100%;
    margin-right: 16px;
    .item {
      padding: 0;
      border: 1px solid transparent;
      border-radius: 4px;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1);
      background-color: #fff;
      margin-bottom: 20px;
      .el-icon-delete,.el-icon-remove-outline {
        &:hover {
          color: #F56C6C;
        }
      }
      .el-icon-document-copy {
        &:hover {
          color: #3377FF;
        }
      }
    }
    .errorMessage {
      color: #FFFFFF;
      background-color: #F56C6C;
      padding: 10px 20px;
      font-size: 14px;
      border-radius: 0 0 4px 4px;
    }
    .active {
      border-color: #2A5EFF;
    }
    .error {
      border-color: #F56C6C;
    }
  }
  .ghost {
    background-color: #499BFF;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 20px;
    .iconfont {
      display: none;
    }
    span {
      color: #FFFFFF;
    }
  }
}
.setting {
  width: 200px;
  padding: 20px;
  font-size: 14px;
}
</style>
